import React from "react";
import { motion } from "framer-motion";
import { meetingLink } from "../../data/navlink";

const bg1 = require("../../assests/bg1.jpeg");
const img = require("../../assests/AnilDhyani.jpeg");

export default function MeetTheFirm() {
  return (
    <div className="w-full bg-white rounded-lg">
      {/* Hero Section */}
      <motion.div
        className="relative w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
      >
        <img src={bg1} alt="Law Firm" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          <h1 className="text-3xl md:text-5xl font-bold text-goldenYellow text-center">
            Meet Our Firm
          </h1>
        </div>
      </motion.div>

      {/* Firm Overview */}
      <motion.div
        className="mt-10 text-center px-2 md:px-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="md:text-3xl text-2xl font-bold text-[#0F172A]">
          About Anil Dhyani & Associates
        </h2>
        <div className="w-20 h-1 bg-[#C9A227] mx-auto mt-2 rounded-full"></div>
        <div className="text-gray-700 mt-6 text-lg max-w-4xl mx-auto flex flex-col gap-2 text-start  md:text-justify">
        <p>  Established in 1992, Anil Dhyani & Associates has been a cornerstone of legal excellence for over three decades. Grounded in expertise, integrity, and a forward-thinking approach, we are dedicated to providing impactful, results-oriented legal solutions across a diverse range of practice areas.</p>
        <p>  Our firm is led by Anil Dhyani, a distinguished legal professional with a remarkable legacy as former Vice President, a certified mediator, and a trainer mediator for the Delhi Government’s Mediation Training Centre (NTC). Alongside him is Saket N. D., former Spokesperson of the Coordination Committee of All District Court Bar Associations in Delhi. Their combined leadership and vast experience empower our team to uphold the highest standards of professionalism and efficiency in serving our clients.</p>
        <p>  Our dynamic team comprises skilled lawyers specializing in civil, criminal, corporate, taxation, family, IT, startup, and intellectual property (IP) law. We pride ourselves on our creative and comprehensive approach, looking beyond the surface of facts and law to craft tailored strategies that meet our clients’ unique needs.</p>
          <p>At Anil Dhyani & Associates, we believe in fighting the right fight, the right way. Our clients receive not only exceptional legal representation but also thoughtful, strategic counsel designed to achieve effective and efficient outcomes. We think outside the box, ensuring innovative solutions that stand the test of complexity.</p>
          <p>More than just legal advisors, we are your trusted partners, dedicated to guiding you through the intricacies of the legal landscape with confidence and clarity.</p>
        </div>
      </motion.div>

      {/* Founder Section */}
      <motion.div
        className="mt-12 flex flex-col md:flex-row items-center gap-8 bg-gray-100 p-6 md:p-10 rounded-lg shadow-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <img
          src={img}
          alt="Founder - Anil Dhyani"
          className="w-48 h-48 object-cover rounded-full border-4 border-[#C9A227] shadow-md"
        />
        <div className="text-center md:text-left">
          <h3 className="text-2xl font-bold text-[#0F172A]">Anil Dhyani</h3>
          <p className="text-gray-600 text-lg italic">Advocate | Founder, Anil Dhyani and Associates</p>
          <p className="text-gray-700 mt-4 leading-relaxed">
          Mr Anil Dhyani is a practicing advocate with experience in civil, criminal, and commercial law. They provide legal services in litigation, arbitration, and advisory matters, ensuring diligent and ethical representation for clients.
          </p>
        </div>
      </motion.div>

      {/* Core Values */}
      {/* <motion.div
        className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-12"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {[
          { title: "Integrity", desc: "We uphold the highest ethical standards in every case." },
          { title: "Client-Centric", desc: "Our priority is delivering exceptional results for our clients." },
          { title: "Excellence", desc: "We are committed to legal expertise and outstanding service." },
        ].map((value, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 p-6 rounded-lg shadow-lg text-center"
            whileHover={{ scale: 1.05 }}
          >
            <h3 className="text-xl font-bold text-[#0F172A]">{value.title}</h3>
            <p className="text-gray-600 mt-2">{value.desc}</p>
          </motion.div>
        ))}
      </motion.div> */}

      {/* Call-to-Action */}
      <motion.div
        className="mt-12 text-center px-6 md:px-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h3 className="text-2xl font-bold text-[#0F172A]">
          Need Legal Assistance?
        </h3>
        <p className="text-gray-600">Schedule a consultation with our experts today.</p>
        <motion.button
        onClick={() => window.location.href = `${meetingLink }`}

          className="mt-4 px-6 py-3 bg-[#C9A227] text-[#0F172A] font-semibold rounded-lg shadow-lg hover:bg-[#B79527] transition-all duration-300"
          whileHover={{ scale: 1.05 }}
        >
          Book a Consultation
        </motion.button>
      </motion.div>
    </div>
  );
}
